import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {
  catalogBibShape,
  listShape,
  userIdentityShape,
  paginationShape,
  libraryShape
} from '@bibliocommons/bc-prop-types';
import { ChevronLink } from '@bibliocommons/base-links';
import ListCard from '@bibliocommons/list-card';
import Context from '@bibliocommons/context';
import AddToListDropdown from 'app/components/bibs/shared/AddToListDropdown';

import './CommunityLists.scss';

export default function CommunityLists({ lists, pagination, catalogBib, users, library }) {
  const { mobileApp } = useContext(Context);

  function renderContent() {
    if (lists?.size > 0) {
      const metadataId = catalogBib.get('metadataId');
      const totalCount = pagination.get('count');

      return (
        <div className="community-lists-content">
          <ul>
            {lists.map(list => (
              <li key={list.get('id')}>
                <ListCard
                  creator={users.get(list.getIn(['owner', 'id']).toString())}
                  library={library}
                  list={list}
                  titleTag="div"
                  horizontal
                  smallCreatorLink
                  smallHeading
                />
              </li>
            ))}
          </ul>
          {totalCount > lists.size && (
            <ChevronLink
              className="view-all-link"
              dataKey="view-all-community-lists"
              href={`/v2/record/${metadataId}/lists?category=COMMUNITY`}
            >
              <FormattedMessage id="view_all_community_lists" values={{ count: totalCount }} />
            </ChevronLink>
          )}
        </div>
      );
    }

    return (
      <div className="empty-community-lists">
        <FormattedMessage id="empty_community_lists" />
      </div>
    );
  }

  if (mobileApp && !lists?.size) return null;

  return (
    <div className="cp-community-lists">
      <div className="community-lists-heading">
        <FormattedMessage tagName="h3" id="community_lists_featuring_title" />
      </div>
      <AddToListDropdown catalogBib={catalogBib} overlayKey="add-to-list-overlay-community-lists" />
      {renderContent()}
    </div>
  );
}

CommunityLists.propTypes = {
  library: libraryShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  pagination: paginationShape.isRequired,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired
};
